/**
 * The "search on submit" box of the catalogue and stock lists: the text is
 * applied by the magnifying glass or Enter.
 */
import type { CSSProperties } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export interface SearchFormProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  /** Style of the wrapper (`flex: 1` in the catalogue, nothing in the stocks). */
  style?: CSSProperties | undefined;
  testId?: string | undefined;
}

export function SearchForm({
  value,
  onChange,
  onSubmit,
  style,
  testId,
}: Readonly<SearchFormProps>) {
  return (
    <div style={style}>
      <form
        className="input-group"
        style={{ maxWidth: 300 }}
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <input
          type="text"
          className="form-control shadow-none"
          placeholder="Search"
          aria-label="Search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          data-testid={testId ? `${testId}-input` : undefined}
        />
        <button
          type="submit"
          className="btn border px-3 shadow-none"
          aria-label="Search"
          data-testid={testId ? `${testId}-button` : undefined}
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </form>
      <div className="search-hint">
        To activate your search, please click the magnifying glass icon or press
        Enter.
      </div>
    </div>
  );
}
